import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=e18c6d70&scoped=true&"
import script from "./DownloadLink.vue?vue&type=script&lang=js&"
export * from "./DownloadLink.vue?vue&type=script&lang=js&"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=e18c6d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18c6d70",
  null
  
)

export default component.exports